import { useEffect, useState } from "react";
import { useAppSelector } from "store";
import { SvgTableOfContents, SvgWindowSplitVertical } from "@itwin/itwinui-icons-react";
import { ButtonGroup, Header, IconButton, Tooltip } from "@itwin/itwinui-react";
import { BuildButton } from "./BuildButton";
import styles from "./EditorHeader.module.css";
import { Tabs } from "./Tabs";

export interface EditorHeaderProps {
  onReset: () => void;
  expanded: boolean;
  fileExplorerExpanded?: boolean;
  onShowFileExplorer?: () => void;
}

export const EditorHeader = ({ onReset, expanded: fullScreen, fileExplorerExpanded, onShowFileExplorer }: EditorHeaderProps) => {
  const layout = useAppSelector((state) => state.settings.layout);
  const [expanded, setExpanded] = useState(fullScreen);

  const onResetClick = () => {
    setExpanded(false);
    onReset();
  }

  useEffect(() => setExpanded(fullScreen), [fullScreen]);

  // display as floating toolbar in the right corner of editor. No tabs
  if (layout.toolbars === false) {
    return (
      <div className={styles.toolbarOverlay}>
        <div className={styles.toolbar}>
          <ButtonGroup>
            {fileExplorerExpanded && <Tooltip key="reset-btn" content={"Show file explorer"} placement="bottom" delay={500}>
              <IconButton styleType="borderless" onClick={onShowFileExplorer} ><SvgTableOfContents /></IconButton>
            </Tooltip>}
            {layout.previewPanel !== "hidden" &&
              <Tooltip content={"Reset windows"} placement="bottom" delay={500}>
                <IconButton styleType="borderless" onClick={onResetClick} className={!expanded ? styles.hidden : ""} ><SvgWindowSplitVertical /></IconButton>
              </Tooltip>}
            <BuildButton />
          </ButtonGroup>
        </div>
      </div>
    );
  }

  return (
    <Header
      appLogo={null}
      isSlim={true}
      className={styles.hideLogoDivider}
      breadcrumbs={[
        <Tabs key="file-tabs" />
      ]}
      actions={[
        <BuildButton key="build-btn" />,
        <Tooltip key="reset-btn" content={"Reset windows"} placement="bottom" delay={500}>
          <IconButton styleType="borderless" onClick={onResetClick} className={[!expanded ? styles.hidden : ""].join(" ")} data-testid="atp-reset-editor"><SvgWindowSplitVertical /></IconButton>
        </Tooltip>
      ]}
    />
  )
}